import axios from 'axios';
import _get from 'lodash/get';
import isEmpty from 'lodash/isEmpty'
import { SERVER_URL } from '../../../../constants/ClientConfig';
import { railsConfig } from '../../../../API/railsConfig';
import { getSessionID } from '../../../../utils/interceptorUtils';
import { getUserInfoPIIClient } from 'pwa-mmt-ui-header/getPIIData/client';
import { trackApplyCouponClicked, trackRemoveCouponClicked } from '../../../../xdm/travellerEvents';
import {
  ADD_COUPON,
  ADD_RECOMMENDED_COUPONS,
  ADD_FORM,
  BOARDING_STATIONS,
  BOOKING_REVIEW, CHANGE_SELECTED_COUPON,
  FETCH_TRAVELLERS,
  LOAD_TRAVELLERS, REMOVE_COUPON,
  SHOW_ERROR,
  SUBMIT_FORM,
  TOGGLE_INSURANCE,
  TOGGLE_PREFERENCE,
  UPDATE_BOARDING_STATION,
  UPDATE_RESERVATION_CHOICE,
  UPDATE_USER_DETAIL,
  SET_ADDRESS_LINE1,
  SET_ERROR_ADDL1,
  SET_ADDRESS_LINE2,
  SET_ERROR_ADDL2,
  SET_ADDRESS_LINE3,
  SET_ERROR_ADDL3,
  SET_PINCODE,
  SET_STATE,
  SET_CITY,
  SET_POST_OFFICE,
  SET_ERROR_PINNO,
  SET_POST_OFFICE_LIST,
  GET_ADDRESS_FROM_LS,
  ACTION_SET_FREE_CANCELLATION,
  SET_ERROR_IRCTC_USER_ID,
  ACTION_RAILOFY_RESPONSE,
  SAVE_RAILOFY_OPTIONS,
  ACTION_ON_SELECT_CNFM_GUARANTEE,
  ACTION_RAILOFY_ERROR,
  ACTION_RAILOFY_LOADING,
  ACTION_VALIDATING_COUPON,
  ACTION_SET_OR_RESET_LOGIN_MODAL,
  ACTION_SHOW_IRCTC_VERIFICATION_MODAL,
  SHOW_GSTIN_COMPONENT,
  GSTIN_STATE,
  GSTIN_USERCONSENT,
  GSTIN_USERCONSENT_ERROR,
  GSTIN_STATE_ERROR,
  UPDATE_TRIP_TAG_DETAILS,
  ACTION_ZCSHOW_ERROR,
  ACTION_FC_TG_FIRST_SELECTION,
  ACTION_ON_AVAIL_SUBSCRN,
  UPDATE_REVIEW_VERIFICATION_FLOW,
} from '../../../../constants/ActionTypes';
import { getClassType } from '../../../../constants/Classes';
import { getReservationChoices, ReservationChoices } from '../../../../constants/ReservationChoices';
import { getQuotaType, Quotas, isTatkalQuota } from '../../../../constants/Quotas';
import {
  AADHAR_MODAL_FIRED,
  AGE_DEFAULT,
  BERTH_PREFERENCE_DEFAULT,
  COUNTRY_PREFERENCE_DEFAULT,
  FC_OPTED_TRACKING_KEY,
  FC_TG_TRACKING_IDENTIFIER,
  FREE_CANCELLATION,
  GENDER_DEFAULT,
  GUEST_TRAVELLERS,
  LOGGED_IN_TRAVELLERS,
  MEAL_PREFERENCE_DEFAULT,
  MMT_AUTH, MULTI_SELECT, MY_BUSINESS_SUBSCRIPTION,
  NAME_DEFAULT,
  PAGES,
  RESERVATION_CHOICE_DEFAULT,
  RESERVATION_TYPE_DEFAULT,
  SENIOR_CITIZEN_CONCESSION_DEFAULT,
  STORAGE_CONSTANTS,
  TG_OPTED_TRACKING_KEY,
  TRAVELLERS_TRACKING_KEY,
  TRIP_GUARANTEE,
  isHdfcSmartBuyUrl
} from '../../../../constants/TrainConstants';
import { getGender, getGenderOptions } from '../../../../constants/Genders';
import { getNationalityOptions } from '../../../../constants/Countries';
import { Berths, getBerthTypes } from '../../../../constants/Berths';
import { DEFAULT_FOOD_TYPE, getApplicableFoodTypes, getMealOptions, getMealPreferenceOptions } from '../../../../constants/Meals';
import { getReservationTypeOptions } from '../../../../constants/ReservationType';
import { getSrCitizenOptions } from '../../../../constants/SrCitizenConcessions';
import { getBerthPref, getCookie, getShortName } from '../../../../utils/trainUtils';
import { isChild, isHalfTicket, isInfant, isSeniorCitizen } from '../../../../constants/Validators';
import { InsuranceStates } from '../../../../constants/InsuranceStates';
import { setFunnelVarsForUser, trackEvar47EventAfterRemovigOlderEvent } from '../../../../utils/railsAnalytics';
import { TrainTypes } from '../../../../constants/TrainConstants';
import { ADDRESS_LS_KEY } from '../../components/TravellerContactInfo/AddressDetails/addressDetails.constants';
import { getDeviceId, getMMTAuth,getSmartBuyHeader } from '../../../../utils/readCookie';
import PDTInfo from '../../../../utils/pdtInfo';
import {getAdvancePurchaseDays} from '../../../../components/GTM/GTMConfig'
import fecha from 'fecha';
import { getMyBizHeaders, isBussinessUser, isUserLoggedIn } from '../../../../utils/BizUtils';
import { fetchUserStatusAPI, setUserStatusAction } from './UserActions';
import {
  setItemBySession,
  getItemBySession,
  itemType
} from 'MMT-UI/storages/client/sessionStorage';
import { checkAvailability } from '../../../listing/listingStore/ListingActions';
import { generateId } from '../../../../utils/trainUtils';
import { fcPlusTgVersion } from '../../../../constants/AbConfigKeys';
import { 
  AVAILABILITY_ALERT_SET_SUCCESSFULLY, 
  AVAILABILITY_ALERT_REMOVED_SUCCESSFULLY 
} from '../../../../components/AvailabilitySubscription/constants';
import { transformTrainData } from '../../../../utils/trainDataTransformers';

const AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES = {
  INITIALISE: 'INITIALISE',
  UPDATE: 'UPDATE'
};

const calCulateTimeInMilliSeconds = ({departureTime,doj})=>{
  let departTime = departureTime.split(':');
  let departHour = Number(departTime[0])*3600 + Number(departTime[1]) * 60
  let year = doj.substring(0, 4);
  let month = doj.substring(4, 6);
  let day = doj.substring(6, 8);
  let departureDateString = new Date(year, month-1, day);
  return {date:departureDateString, time:departureDateString.getTime() + departHour*1000}
}
export const boardingStationsAction = (reqParams) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    const { trainNumber, frmStnCode, toStnCode, selectedClass, doj, alternateAvailability, boardingStation, confirmedOptions } = reqParams;
    const res = await axios.get(`${SERVER_URL}/boardingStations/${trainNumber}/${doj}/${frmStnCode}/${toStnCode}/${selectedClass}`,{ headers });
    const boardingStationsList = res.data.stationList;
    const depJourneyDate = res.data.departureDate;
    const arrivalJourneyDate = res.data.arrivalDate;
    dispatch({
      type: BOARDING_STATIONS,
      payload: {
        boardingStationsList,
        alternateAvailability,
        boardingStation,
        arrivalJourneyDate,
        depJourneyDate,
        confirmedOptions
      }
    });
  } catch (error) {
    console.error(error);
  }
};

export const getRailInfo = () => async (dispatch) => {

  const urlParams = new URLSearchParams(window.location.search);
  
  const source = urlParams.get('from');
  const destination = urlParams.get('to');
  const doj = urlParams.get('departure');
  const trainNumber = urlParams.get('trainNumber');
  const classCode = urlParams.get('classCode');
  const quota = urlParams.get('quota');
  const mmtAuth = getCookie(MMT_AUTH);
  const myBusinessSubscription = getCookie(MY_BUSINESS_SUBSCRIPTION) || 'b2c';
  const traceId = generateId();
  let headers = {
    ...await getMyBizHeaders(),
    "mmt-auth":getCookie(MMT_AUTH),
    "mmt-device-id": getDeviceId(),
    "mmt-my-business-subscription": myBusinessSubscription,
    "mmt-os": "desktop",
    "X-Trace-Id": traceId,
    "x-alternate-availability-type": "1",
    "x-supported-rtb-version": "v2",
    "accept": "application/json",
    "cache-control": "no-cache",
    "content-type": "application/json",
  }
    
  const availabilityResponsePayload = {
    source,
    destination,
    doj,
    trainNumber,
    class: classCode,
    quota,
    moreThanOneDay: false,
  }

  const availabilityResponse = await checkAvailability(availabilityResponsePayload, headers);
  const availabilityResponseData = availabilityResponse?.data || null;

  const tbsUrl = `${railsConfig.tbsWithAvailabilityUrl}/${source}/${destination}/${doj}`;
  const tbsResponse = await axios.get(tbsUrl, {headers});
  
  // Add null checks for response data
  if (!tbsResponse || !tbsResponse.data) {
    throw new Error('Invalid response from train service');
  }
  
  const railSearchData = tbsResponse.data.trainBtwnStnsList;
  
  // Add null check for railSearchData array
  if (!railSearchData || !Array.isArray(railSearchData)) {
    throw new Error('Invalid train list data format');
  }
  
  const train = railSearchData.find((tr) => tr && trainNumber === tr.trainNumber);
  
  // Add null check for train
  if (!train) {
    throw new Error(`Train ${trainNumber} not found in search results`);
  }
  
  // Transform train data to add 12-hour format fields
  const transformedTrain = transformTrainData(train);
  
  const railInfo = {
    selectedClass: classCode,
    selectedQuota: quota,
    doj,
    availabilityBookingConfig: availabilityResponseData,
    train: transformedTrain,
    availability: availabilityResponseData?.avlDayList?.[0],
  }

  dispatch({
    type: LOAD_TRAVELLERS,
    payload: {
      railInfo,
    },
  });

  return railInfo;
}

export const loadTravellersPage = (railInfo) => async (dispatch) => {
  const traceId = generateId();
  const {
    availability:{prettyPrintingAvailablityStatus,quota,availablityType,lastUpdatedOnRaw,availablityStatus},
    availabilityBookingConfig: { bkgCfg, totalCollectibleAmount, travelAdvisoryDetails,tatkalFare,totalFare,applicableFoodTypes },
    selectedClass,
    selectedQuota,
    doj,
    train:{departureTime,trainNumber,trainName,trainType,duration,frmStnCode,
      frmStnName,
      toStnCode,
      toStnName}
  } = railInfo;
  const departure_date_time = calCulateTimeInMilliSeconds({departureTime,doj})
  const pdtTravellingBody = {
    eventType : "TRAVELLER",
    data:{
      departureDate:fecha.format(departure_date_time.date, 'YYYY-MM-DD').split('-').join(''),
      frmStnCode,
      frmStnName,
      toStnCode,
      toStnName,
      from_city_name: frmStnName,
      to_city_name: toStnName,
      boarding_station_name: null,
      boarding_time: null,
      departure_time: departure_date_time.time,
      arrival_time: departure_date_time.time + (1000*60*duration),
      quota: selectedQuota,
      journeyClass: selectedClass,
      train_name: trainName,
      train_number: trainNumber,
      journey_date: doj,
      price: totalFare,
      availability: prettyPrintingAvailablityStatus,
      availabilityType: availablityType,
      waitListNumber: availablityStatus.toLowerCase().includes('w')? prettyPrintingAvailablityStatus.split(' ')[1]: null,
      availability_last_updated: lastUpdatedOnRaw,
      advance_purchase: getAdvancePurchaseDays(doj),
      duration,
      ...PDTInfo()
    }
  }

  const headers = {
    "mmt-auth":getCookie(MMT_AUTH),
    "X-Trace-Id": traceId
}
  const pdtTraveller = `${SERVER_URL}/postPdtData`
  axios.post(pdtTraveller,pdtTravellingBody,{headers})
  const bookingReviewResponse = {};
  const reservationOptions = getReservationChoices(bkgCfg.lowerBerthApplicable);
  const showTatkalMessage = getQuotaType(selectedQuota).code === Quotas.TQ.code;
  const { maxPassengers: maxTravellersAllowed } = bkgCfg;
  const genderOptions = getGenderOptions();
  const nationalityOptions = getNationalityOptions();
  const berthPreferenceOptions = getBerthTypes([ ...(bkgCfg.applicableBerthTypes || []), '' ]);
  const mealPreferenceOptions = getApplicableFoodTypes(applicableFoodTypes);
  const reservationTypeOptions = getReservationTypeOptions();
  const srCitizenOptions = getSrCitizenOptions();
  const options = { genderOptions,
    nationalityOptions,
    berthPreferenceOptions,
    mealPreferenceOptions,
    reservationTypeOptions,
    srCitizenOptions,
    reservationOptions };
  const selectedReservationChoice = RESERVATION_CHOICE_DEFAULT(bkgCfg.lowerBerthApplicable);
  const showError = false;
  const couponErrorMessage = '';
  const coupons = [];
  const boardingStations = [];
  const travelInsuranceOpted = InsuranceStates.FALSE;
  const captureAddress = bkgCfg.captureAddress ? bkgCfg.captureAddress : false;
  const railofyOptions = {
    railofyShown: Boolean(railInfo && railInfo.availability && railInfo.availability.confirmationGuaranteeText),
    zcShown: Boolean(railInfo && railInfo.availability && railInfo.availability.freeCancellationText),
  };
  //const captureAddress = true;
  dispatch({
    type: LOAD_TRAVELLERS,
    payload: {
      railInfo,
      quotaType: getQuotaType(selectedQuota),
      classType: getClassType(selectedClass),
      totalCollectibleAmount: parseFloat(totalCollectibleAmount),
      maxTravellersAllowed,
      options,
      selectedReservationChoice,
      showTatkalMessage,
      bookingReviewResponse,
      showError,
      travelInsuranceOpted,
      couponErrorMessage,
      coupons,
      boardingStations,
      captureAddress,
      travelAdvisoryDetails,
    },
  });
  dispatch({
    type: SAVE_RAILOFY_OPTIONS,
    payload: railofyOptions,
  });
};

export const fetchTravellersAction = (railInfo) => async (dispatch) => {
  if(isEmpty(railInfo)) {
    return;
  }
  const { availabilityBookingConfig: { bkgCfg: { maxPassengers: maxTravellersAllowed }, applicableFoodTypes } } = railInfo;
  const traceId = generateId();
  try {
    const mmtId = getCookie(MMT_AUTH);
    const travellersData = getItemBySession(
      mmtId ? LOGGED_IN_TRAVELLERS : GUEST_TRAVELLERS,
      { isPiiData: true, shouldParseJson: true },
      itemType.ES
    );
    const guestTravellers =  mmtId ? getItemBySession(GUEST_TRAVELLERS, 
      { isPiiData: true, shouldParseJson: true }, 
      itemType.ES) : null;
    let travellers = {};
    let name = '';
    let email = '';
    let mobileNumber = '';
    if (mmtId) {
      const res = await axios.get(`${SERVER_URL}/user/details`,{ headers: { "mmt-auth": mmtId,"X-Trace-Id": traceId } });
      name =
        res.data.name
          .trim()
          .split(/\s+/)
          .join(" ") ||
        getItemBySession(
          STORAGE_CONSTANTS.NAME,
          { isPiiData: true, shouldParseJson: true },
          itemType.ES
        ) ||
        "";
      email = res.data.email || getItemBySession(
        STORAGE_CONSTANTS.EMAIL,
        { isPiiData: true, shouldParseJson: true },
        itemType.ES
      ) || '';
      mobileNumber =
        res.data.mobileNumber.length > 10
          ? res.data.mobileNumber.substring(2)
          : res.data.mobileNumber ||
            getItemBySession(
              STORAGE_CONSTANTS.MOBILE_NUMBER,
              { isPiiData: true, shouldParseJson: true },
              itemType.ES
            ) ||
            "";
      const travellersResponse = res.data.associatedTravellers;
      if (travellersData) {
        const travellersFromServer = Object.entries(travellersResponse)
          .reduce((a, [ key, { name, age, gender } ]) =>
            ({
              ...a,
              [ key ]: {
                name,
                age,
                gender: gender ? getGender(gender) : GENDER_DEFAULT,
              },
            }), {});
        const travellersFromCache = Object.entries(travellersData)
          .reduce((a, [ key, { name, age, gender, active, nationality, berthPref, mealPref, mealPrefEdited, srCitConcession, reservationType, travellerEdited } ]) =>
            ({
              ...a,
              [ key ]: {
                name,
                age,
                gender,
                active: false,
                nationality,
                berthPref,
                mealPref,
                mealPrefEdited,
                srCitConcession,
                reservationType,
                travellerEdited,
              },
            }), {});
        travellers = Object.keys(travellersFromServer)
          .reduce((a, key) => {
            const serverTrv = travellersFromServer[ key ];
            const cacheTrv = travellersFromCache[ key ];
            const defaultTrv = {
              nationality: COUNTRY_PREFERENCE_DEFAULT,
              berthPref: BERTH_PREFERENCE_DEFAULT,
              mealPref: MEAL_PREFERENCE_DEFAULT,
              srCitConcession: SENIOR_CITIZEN_CONCESSION_DEFAULT,
              reservationType: RESERVATION_TYPE_DEFAULT,
            };
            const travellerEdited = cacheTrv?.travellerEdited === true;
            return ({
              ...a,
              [ key ]: {
                ...defaultTrv,
                ...cacheTrv,
                ...(travellerEdited ? {} : serverTrv),
              },
            });
          }, {});
      } else {
        travellers = Object.entries(travellersResponse)
          .reduce((a, [ key, { name, age, gender } ]) =>
            ({
              ...a,
              [ key ]: {
                name,
                age,
                gender: gender ? getGender(gender) : GENDER_DEFAULT,
                active: false,
                nationality: COUNTRY_PREFERENCE_DEFAULT,
                berthPref: BERTH_PREFERENCE_DEFAULT,
                mealPref: MEAL_PREFERENCE_DEFAULT,
                srCitConcession: SENIOR_CITIZEN_CONCESSION_DEFAULT,
                reservationType: RESERVATION_TYPE_DEFAULT,
              },
            }), {});
      }
      if (guestTravellers && Object.keys(guestTravellers).length > 0) {
        const allTravellers = [
          ...Object.values(guestTravellers).map(t => ({ ...t, active: t.active || false })),
          ...Object.values(travellers)
        ];
        travellers = allTravellers.reduce((acc, traveller, index) => {
          acc[index] = traveller;
          return acc;
        }, {});
      }
      const userProps = { name, email, mobileNumber: res.data.mobileNumber };
      setFunnelVarsForUser(userProps);
    } else {
      name = getItemBySession(
        STORAGE_CONSTANTS.NAME,
        { isPiiData: true, shouldParseJson: true },
        itemType.ES
      ) || '';
      email = getItemBySession(
        STORAGE_CONSTANTS.EMAIL,
        { isPiiData: true, shouldParseJson: true },
        itemType.ES
      ) || '';
      mobileNumber = getItemBySession(
        STORAGE_CONSTANTS.MOBILE_NUMBER,
        { isPiiData: true, shouldParseJson: true },
        itemType.ES
      ) || '';
      if (travellersData) {
        const travellersFromCache = Object.entries(travellersData)
          .reduce((a, [ key, { name, age, gender, active, nationality, berthPref, mealPref, mealPrefEdited, srCitConcession, reservationType, travellerEdited } ]) =>
            ({
              ...a,
              [ key ]: {
                name,
                age,
                gender,
                active: false,
                nationality,
                berthPref,
                mealPref,
                mealPrefEdited,
                srCitConcession,
                reservationType,
                travellerEdited,
              },
            }), {});
        travellers = Object.keys(travellersData)
          .reduce((a, key) => {
            const cacheTrv = travellersFromCache[ key ];
            const defaultTrv = {
              name: NAME_DEFAULT,
              age: AGE_DEFAULT,
              gender: GENDER_DEFAULT,
              active: false,
              nationality: COUNTRY_PREFERENCE_DEFAULT,
              berthPref: BERTH_PREFERENCE_DEFAULT,
              mealPref: MEAL_PREFERENCE_DEFAULT,
              srCitConcession: SENIOR_CITIZEN_CONCESSION_DEFAULT,
              reservationType: RESERVATION_TYPE_DEFAULT,
            };
            return ({
              ...a,
              [ key ]: {
                ...defaultTrv,
                ...cacheTrv,
              },
            });
          }, {});
      }
      const userProps = { name: 'Guest' };
      setFunnelVarsForUser(userProps);
    }
    setItemBySession(
      mmtId ? LOGGED_IN_TRAVELLERS : GUEST_TRAVELLERS,
      travellers,
      { isPiiData: true, shouldStringifyJson: true },
      itemType.ES
    );
    const mealOptions = getApplicableFoodTypes(applicableFoodTypes) || [];
    const defaultMealPref = mealOptions[0] || { text: DEFAULT_FOOD_TYPE.value };
    if (travellers) {
      Object.values(travellers).forEach(traveller => {
        if (traveller.mealPrefEdited) {
          const isPrefAvailable = mealOptions.some(
            option => option.id === traveller.mealPref?.id
          );
          if (!isPrefAvailable) {
            traveller.mealPref = defaultMealPref;
            traveller.mealPrefEdited = false;
          }
        } else {
          traveller.mealPref = defaultMealPref;
        }
      });
    }
    const selectedTravellers = Object.keys(travellers).filter((key) => travellers[ key ].active)
      .reduce((a, key) => ({ ...a, [ key ]: travellers[ key ] }), {});
    const travellerExceeded = Object.keys(selectedTravellers).length > maxTravellersAllowed;
    const travellerBerth = Object.keys(selectedTravellers).filter((key) => selectedTravellers[ key ].reservationType.id === 'H').length
      > Object.keys(selectedTravellers).filter((key) => selectedTravellers[ key ].reservationType.id === 'F').length;
    const viewAll = Object.keys(selectedTravellers).length > 3;
    dispatch({
      type: FETCH_TRAVELLERS,
      payload: {
        travellers,
        selectedTravellers,
        name,
        email,
        mobileNumber,
        travellerExceeded,
        travellerBerth,
        viewAll,
      },
    });
  } catch (error) {
    console.error(error);
  }
};
// edit below 2 functions to be able to add primaryTraveller option in line 569
export const submitFormAction = (id, data) => async (dispatch, getState) => {
  const traceId = generateId();
  const travellerId = id;
  const mmtId = getCookie(MMT_AUTH);
  const isB2b = isBussinessUser();
  const { traveller: { travellers, maxTravellersAllowed } } = getState();
  const travellerData = { ...travellers[ travellerId ], ...data };
  const { name, age, gender } = travellerData;
  const trimmedName = name.trim().split(/\s+/).join(' ');
  const mealPrefChanged = data.mealPref && data.mealPref.id !== travellers[travellerId]?.mealPref?.id;
  const updatedData = { 
    ...data, 
    name: trimmedName,
    ...(mealPrefChanged && { mealPrefEdited: true }),
    ...(data.name && { travellerEdited: true }),
  };
  const updatedTravellerData = { ...travellerData, name: trimmedName, ...(mealPrefChanged && { mealPrefEdited: true }), ...(data.name && { travellerEdited: true }) };
  const updatedTravellers = { ...travellers, [ id ]: updatedTravellerData };
  const body = { travellerId, name: trimmedName, age, gender };
  const selectedTravellers = Object.keys(updatedTravellers).filter((key) => updatedTravellers[ key ].active)
    .reduce((a, key) => ({ ...a, [ key ]: updatedTravellers[ key ] }), {});
  const travellerExceeded = Object.keys(selectedTravellers).length > maxTravellersAllowed;
  const travellerBerth = Object.keys(selectedTravellers).filter((key) => selectedTravellers[ key ].reservationType.id === 'H').length
    > Object.keys(selectedTravellers).filter((key) => selectedTravellers[ key ].reservationType.id === 'F').length;
  setItemBySession(
    mmtId ? LOGGED_IN_TRAVELLERS : GUEST_TRAVELLERS,
    updatedTravellers,
    { isPiiData: true, shouldStringifyJson: true },
    itemType.ES
  );
    const headers = {
      "mmt-auth": getCookie(MMT_AUTH),
      "mmt-device-id": getDeviceId(),
      "X-Trace-Id": traceId
    };
  if (mmtId && !isB2b) {
    await axios.post(`${SERVER_URL}/user/editTraveller`, body,{ headers });
  }
  dispatch({
    type: SUBMIT_FORM,
    payload: { id, data: updatedData, selectedTravellers, travellerExceeded, travellerBerth },
  });
};

export const addFormAction = (body) => async (dispatch, getState) => {
  const traceId = generateId();
  const { name } = body;
  const traveller = { ...body, name: name.trim().split(/\s+/).join(' ') };
  const mmtId = getCookie(MMT_AUTH);
  const isB2b = isBussinessUser();
  const { traveller: { travellers: travellersData, maxTravellersAllowed } } = getState();
  let updatedTravellers = travellersData;
  if (mmtId && !isB2b) {
      const headers = {
        "mmt-auth": getCookie(MMT_AUTH),
        "mmt-device-id": getDeviceId(),
        "X-Trace-Id": traceId
      };
    const res = await axios.post(`${SERVER_URL}/user/addTraveller`, traveller,{ headers });
    const { travellerId } = res.data;
    updatedTravellers = { ...travellersData, [ travellerId ]: traveller };
  } else {
    updatedTravellers = { ...travellersData, [ Object.keys(travellersData).length ]: traveller };
  }
  const selectedTravellers = Object.keys(updatedTravellers).filter((key) => updatedTravellers[ key ].active)
    .reduce((a, key) => ({ ...a, [ key ]: updatedTravellers[ key ] }), {});
  const travellerExceeded = Object.keys(selectedTravellers).length > maxTravellersAllowed;
  const travellerBerth = Object.keys(selectedTravellers).filter((key) => selectedTravellers[ key ].reservationType.id === 'H').length
    > Object.keys(selectedTravellers).filter((key) => selectedTravellers[ key ].reservationType.id === 'F').length;
  setItemBySession(
    mmtId ? LOGGED_IN_TRAVELLERS : GUEST_TRAVELLERS,
    updatedTravellers,
    { isPiiData: true, shouldStringifyJson: true },
    itemType.ES
  );
  dispatch({
    type: ADD_FORM,
    payload: { travellers: updatedTravellers, selectedTravellers, travellerExceeded, travellerBerth },
  });
};

export const updateBoardingStationAction = (boardingStation) => (dispatch) => {
  dispatch({
    type: UPDATE_BOARDING_STATION,
    payload: boardingStation,
  });
};

export const changeReservationChoice = (selectedReservationChoice) => (dispatch) => {
  dispatch({
    type: UPDATE_RESERVATION_CHOICE,
    payload: selectedReservationChoice,
  });
};

export const changeUserDetail = (key, value) => (dispatch) => {
  const val = value.trim().split(/\s+/).join(' ');
  setItemBySession(
    key,
    val,
    { isPiiData: true, shouldStringifyJson: true },
    itemType.ES
  );
  dispatch({
    type: UPDATE_USER_DETAIL,
    payload: { [key]: value.trim() },
  });
  dispatch({
    type: UPDATE_USER_DETAIL,
    payload: { [key]: val },
  });

  dispatch({
    type: SET_ERROR_IRCTC_USER_ID,
    payload: { error: true, errorMsg: '' },
  });
};

export const updateTripTagDetails = (data) => (dispatch) => {
  dispatch({
    type: UPDATE_TRIP_TAG_DETAILS,
    payload: data
  })
};

export const togglePreference = (key) => (dispatch, getState) => {
  const { traveller } = getState();
  const newPref = !traveller[key];
  dispatch({
    type: TOGGLE_PREFERENCE,
    payload: { [key]: newPref },
  });
};

export const toggleInsurance = (value) => (dispatch) => {
  dispatch({
    type: TOGGLE_INSURANCE,
    payload: value,
  });
};

const getReservationChoice = ( selectedReservationChoice, confirmBookCheckbox ) => {
  if ( confirmBookCheckbox ) {
    if ( selectedReservationChoice.id === ReservationChoices.None.value ) {
      return ReservationChoices.BookConfirmAndNone.value;
    }
    else if ( selectedReservationChoice.id === ReservationChoices.BookIfAllBerthsAllottedInSameCoach.value ) {
      return ReservationChoices.BookConfirmAndBookIfAllBerthsAllottedInSameCoach.value;
    }
    else if ( selectedReservationChoice.id === ReservationChoices.BookIfAtLeastOneLowerBerthsAllotted.value ) {
      return ReservationChoices.BookConfirmAndBookIfAtLeastOneLowerBerthsAllotted.value;
    }
    else if ( selectedReservationChoice.id === ReservationChoices.BookIfTwoLowerBerthsAllotted.value ) {
      return ReservationChoices.BookConfirmAndBookIfTwoLowerBerthsAllotted.value;
    }
  }
  else {
    return selectedReservationChoice.id;
  }
};

export const bookingAction = (skipAadhaarVerification = false) => async (dispatch, getState) => {
  const traceId = generateId();
  const boardingStationState = _get(getState(),'traveller.selectedBoardingStation',{});
  const psgnDestErrorForLs = _get(getState(), 'traveller.psgnDestError', {});
  const psgnDestErrorMsgForLs = _get(getState(), 'traveller.psgnDestErrorMsg', {});
  const psgnDestinationAddressForLs = _get(getState(), 'traveller.psgnDestinationAddress', {});
  const postOfficeListForLS = _get(getState(), 'traveller.postOfficeList', []);

  const railofy = getState().traveller.railofy;
  const { fcTgFirstSelection } = railofy;

  const {
    ['mmt.desktop.rail.default.default.default.rails_fctg_dweb']: showFcTgTogether,
    [fcPlusTgVersion]: fcTgVersion,
  } = getState().abConfig;

  localStorage.setItem(ADDRESS_LS_KEY, JSON.stringify({
    psgnDestError: psgnDestErrorForLs,
    psgnDestErrorMsg: psgnDestErrorMsgForLs,
    psgnDestinationAddress: psgnDestinationAddressForLs,
    postOfficeList: postOfficeListForLS,
  }));

  const mmtAuth = getCookie(MMT_AUTH);
  const myBusinessSubscription = getCookie(MY_BUSINESS_SUBSCRIPTION);
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const confirmedOptions = JSON.parse(decodeURIComponent(params.get('confirmedOptions')));
  const {
    traveller: {
      selectedCoupon,selectedTravellers, selectedReservationChoice, verifiedUserId, mobileNumber, email, selectedBoardingStation,
      autoUpgradationSelected, travelInsuranceOpted, confirmBookCheckbox, psgnDestinationAddress,
      primaryPax: { primaryTravellerId },
      tripTagDetails: {
        primaryPaxEmail,
        gstDetails = {},
        attributeList = {},
      },
      railInfo: {
        doj,
        alternateAvailability,
        altenativeTrainInfo={},
        train: { frmStnCode: source, toStnCode: destination, trainNumber,
          duration, departureTime,
          clusterTrain, boardingStation,
          frmStnName,toStnName },
        availability: { currentBkgFlag, quota, availablityStatus }, selectedClass, selectedQuota,
        availabilityBookingConfig: {
          bkgCfg: {
            foodChoiceEnabled, seniorCitizenApplicable, childBerthMandatory,
            maxChildAge, srctnwAge, srctznAge, maxNameLength, applicableBerthTypes, minPassengerAge
          },
        },
        requisitionId,
      },
      gstinBillingAddress: {
        state,
      }
    },
    landing: { cmp },
  } = getState();

  if (!skipAadhaarVerification) {
    const quotaType = getQuotaType(selectedQuota);
    if (isTatkalQuota(quotaType) && verifiedUserId) {
      const quota = getState()?.traveller?.railInfo?.selectedQuota ?? null;
      const { userStatus, aadharErrorFlow } = await fetchUserStatusAPI(verifiedUserId, quota);
      
      dispatch(setUserStatusAction(userStatus, aadharErrorFlow));
      if (aadharErrorFlow) {
        trackEvar47EventAfterRemovigOlderEvent(TRAVELLERS_TRACKING_KEY, AADHAR_MODAL_FIRED, AADHAR_MODAL_FIRED);
        dispatch(actionShowIrctcVerificationModal(true));
        return;
      }
    }
  }
  let bkngSrc = cmp;
  const departure_time = calCulateTimeInMilliSeconds({departureTime,doj}).time
  if (bkngSrc && bkngSrc.toLowerCase().includes('irctc')) {
    bkngSrc='IRCTC';
  }
  const berthTypes = [ ...(applicableBerthTypes || []), Berths.NO_BERTH.key ];
  const reservationChoice = getReservationChoice(selectedReservationChoice, confirmBookCheckbox);
  const wsUserLogin = verifiedUserId;
  const boardingStationSelected = currentBkgFlag === 'N' ? selectedBoardingStation.stationCode : source;
  const bookMode = 'D';
  const isB2b = isBussinessUser();
  const trainDetails = { trainNumber, departureTime };
  const fromStationCode = alternateAvailability ? boardingStation.code : source;
  let dropStation =destination;
  if(alternateAvailability)
  {
    dropStation = altenativeTrainInfo?.toStnCode;
  }
  const journeyDetails = { source: fromStationCode, destination:dropStation, class: selectedClass, quota: (quota || selectedQuota), doj, trainDetails,
    departure_time,
    arrival_time: departure_time + (1000*60*duration),
    duration,
    frmCityName:frmStnName,
    fromStationName:frmStnName,
    toStationName: alternateAvailability ? altenativeTrainInfo?.toStnName : toStnName,
    toCityName: alternateAvailability ? altenativeTrainInfo?.toStnName : toStnName,
    advance_purchase: getAdvancePurchaseDays(doj)};
  let newSelectedTravellers = {...selectedTravellers};
  if(isB2b) {
    newSelectedTravellers = Object.keys(newSelectedTravellers).map((id) => ({
      ...newSelectedTravellers[id],
      isPrimaryTraveller: primaryTravellerId === id,
    }))
  }
  const filterPasgnList = Object.values(newSelectedTravellers).filter((traveller)=> traveller.age >= minPassengerAge);
  const passengerList = filterPasgnList
    .map((traveller, index) => ({
      ...(isB2b && {
        passengerEmail: traveller?.email,
        passengerMobileNo: traveller?.mobile || '',
        primaryPassenger: traveller?.isPrimaryTraveller,
      }),
      ...(foodChoiceEnabled && { passengerFoodChoice: traveller.mealPref.id }),
      ...(seniorCitizenApplicable && {
        concessionOpted: isSeniorCitizen(traveller, srctnwAge, srctznAge) ?
          traveller.srCitConcession.obj.key : false,
      }),
      childBerthFlag: isChild(traveller, maxChildAge) ? childBerthMandatory ?
        true : traveller.reservationType.obj.val : false,
      passengerAge: traveller.age,
      passengerBedrollChoice: false,
      passengerBerthChoice: isHalfTicket(traveller) ?
        Berths.NO_BERTH.key : getBerthPref(traveller.berthPref, berthTypes).id,
      passengerGender: traveller.gender.obj.value,
      passengerIcardFlag: false,
      passengerName: getShortName(traveller.name, maxNameLength),
      passengerSerialNumber: index + 1,
      passengerNationality: traveller.nationality.id,
      bedRollFlagEnabled: 'false',
    }));

  const insuranceOpted = travelInsuranceOpted == InsuranceStates.TRUE;
  const couponCode = selectedCoupon.couponCode;
  const cdfTransactionKey = selectedCoupon.cdfTransactionKey;
  const pdtdata = {
      departure_time,
      arrival_time: departure_time + (1000*60*duration),
      duration,
      frmCityName:frmStnName,
      fromStationName:frmStnName,
      toStationName:toStnName,
      toCityName:toStnName,
      advance_purchase: getAdvancePurchaseDays(doj),
      ...PDTInfo(),
  }
  const attributeListArray = Object.values(attributeList);
  const body = {
    ...(isB2b && {
      tripTag: {
        tripTagDetails: {
          primaryPaxEmail,
          ...(!isEmpty(gstDetails) && {gstDetails: gstDetails}),
          attributeList: attributeListArray,
        }
      }
    }),
    reservationChoice,
    wsUserLogin,
    mobileNumber,
    email,
    boardingStation: boardingStationState?.stationCode,
    droppingStation: confirmedOptions?.droppingStation?.code || dropStation,
    passengerList,
    autoUpgradationSelected,
    confirmBookCheckbox,
    travelInsuranceOpted: insuranceOpted,
    bookMode,
    journeyDetails,
    couponCode,
    cdfTransactionKey,
    mmtAuth,
    myBusinessSubscription,
    psgnDestinationAddress: {
      ...psgnDestinationAddress,
      pinCode: parseInt(psgnDestinationAddress.pinCode)
    },
    alternateAvailabilityBooking: alternateAvailability || Boolean(confirmedOptions),
    clusterTrain: clusterTrain,
    listingAvailabilityStatus: availablityStatus,
    bookingSource: bkngSrc,
    ...pdtdata,
    requisitionId,
    pageType: PAGES.TRAVELLER,
    fcTgSelectionType: railofy?.railofyResponse?.fcTgSelectionType,
  };
  if (railofy && railofy.railofyResponse) {
    const { railofyShown, zcShown, railsConfirmationGuaranteeOption } = railofy.railofyResponse;
    // discount only when both are selected and fcTgVersion > 1
    const isDiscounted = fcTgVersion > 1 && railofy.optedForRailofy && railofy.freeCancellationSelected;
    let fcShown = zcShown;
    if(railofyShown) {
      fcShown = showFcTgTogether;
    }
    body.cnfmGuaranteeDetail = {
      cnfmGuaranteeOpted: railofy.optedForRailofy || false,
      railofyShown,
      zcShown: fcShown,
      railsConfirmationGuaranteeOption,
      isDiscounted: isDiscounted && fcTgFirstSelection === FREE_CANCELLATION,
    };
    /**
     * railofy.railofyResponse is updated with cnfmGuaranteePreferences API call
     * so, it has the update railofyShown value.
     */
    if (railofy && railofy.railofyResponse && fcShown){
      if(railofy.railofyResponse.fcTgSelectionType === MULTI_SELECT){
        body.freeCancellationInsuranceDetail = {
          freeCancellationInsuranceOpted: railofy.freeCancellationSelected || false,
          isDiscounted: isDiscounted && fcTgFirstSelection === TRIP_GUARANTEE,
        };
      }
      else if(!railofy.optedForRailofy){
        body.freeCancellationInsuranceDetail = {
          freeCancellationInsuranceOpted: railofy.freeCancellationSelected || false
        };
      }
    }
    if (railofy.optedForRailofy) {
      trackEvar47EventAfterRemovigOlderEvent(
        TRAVELLERS_TRACKING_KEY,
        TG_OPTED_TRACKING_KEY,
        FC_TG_TRACKING_IDENTIFIER,
      );
    } else if (railofy.freeCancellationSelected) {
      trackEvar47EventAfterRemovigOlderEvent(
        TRAVELLERS_TRACKING_KEY,
        FC_OPTED_TRACKING_KEY,
        FC_TG_TRACKING_IDENTIFIER,
      );
    }
    
  }

  if(state) {
    body.gstinBillingAddress = {
      state,
    }
  }

  const headers = {
    "mmt-auth": getCookie(MMT_AUTH) ,
    "mmt-device-id": getDeviceId(),
    "X-Trace-Id": traceId,
    ...getSmartBuyHeader()
  }
  const response = await axios.post(`${SERVER_URL}/booking/review`, body,{headers});
  dispatch({
    type: BOOKING_REVIEW,
    payload: response.data,
  });
};

export const clearReviewResponse = () => async (dispatch) => {
  dispatch({
    type: BOOKING_REVIEW,
    payload: {},
  });
};

export const showValidationError = (flag) => async (dispatch) => {
  dispatch({
    type: SHOW_ERROR,
    payload: flag,
  });
};

export const addCoupon = (text) => async (dispatch, getState) => {
  const traceId = generateId();
  dispatch({
    type: ACTION_VALIDATING_COUPON,
  });
  const mmtAuth = getCookie(MMT_AUTH);
  const myBusinessSubscription = getCookie(MY_BUSINESS_SUBSCRIPTION);
  const { traveller: { railInfo }, landing: { cmp } } = getState();
  const { availability: { availablityDate },
    availabilityBookingConfig: { totalCollectibleAmount, totalFare },
    train: { trainNumber, frmStnCode, toStnCode },
    selectedClass, selectedQuota } = railInfo;
  const body = {
    mmtAuth,
    myBusinessSubscription: mmtAuth ? myBusinessSubscription : 'b2c',
    bookMode: 'D',
    bookingDevice: 'DESKTOP',
    lob: 'rails',
    couponCode: text,
    transactionAmount: totalCollectibleAmount,
    transactionAmountPreTax: totalFare,
    ...(cmp && { cmpId: cmp }),
    trainDetails: {
      trainNo: trainNumber,
      bookingQuota: Quotas[selectedQuota].value,
      class: selectedClass,
      trainType: 'Others',
      travelStartDate: availablityDate,
      trainDepartureCity: frmStnCode,
      trainDestinationCity: toStnCode,
    },
  };
  try {
    const headers = {"X-Trace-Id": traceId};
    const response = await axios.post(`${SERVER_URL}/coupon/validate`, body,{ headers });
    const { data: coupon } = response;
    dispatch({
      type: ADD_COUPON,
      payload: coupon,
    });
    if (coupon && !coupon.errorDetails) {
      try {
        const { listing } = getState();
        await trackApplyCouponClicked({
          railInfo,
          couponCode: text,
          couponDetails: coupon,
          fromStationNode: listing?.fromStationNode,
          toStationNode: listing?.toStationNode,
        });
      } catch (trackingError) {
        console.error('Error tracking apply coupon:', trackingError);
      }
    }
  } catch (error) {
    const coupon = { errorDetails: { errorMessage: 'Please use a valid coupon' } };
    dispatch({
      type: ADD_COUPON,
      payload: coupon,
    });
  }
};

export const removeCoupon = (coupon, skipTracking = false) => async (dispatch, getState) => {
  dispatch({
    type: REMOVE_COUPON,
    payload: coupon,
  });
  
  if (!skipTracking && coupon && coupon.couponCode) {
    try {
      const { traveller: { railInfo }, listing } = getState();
      await trackRemoveCouponClicked({
        railInfo,
        couponCode: coupon?.couponCode || coupon?.code || '',
        couponDetails: coupon,
        fromStationNode: listing?.fromStationNode,
        toStationNode: listing?.toStationNode,
      });
    } catch (trackingError) {
      console.error('Error tracking remove coupon:', trackingError);
    }
  }
};

export const changeSelectedCoupon = (coupon) => async (dispatch) => {
  dispatch({
    type: CHANGE_SELECTED_COUPON,
    payload: coupon,
  });
};

export const addRecommendedCoupons = () => async (dispatch, getState) => {
  const traceId = generateId();
  const mmtAuth = getCookie(MMT_AUTH);
  const mmtuserid = getCookie('MMYTUUID');
  const isLoggedIn = !!mmtAuth;
  const { traveller: { railInfo }, landing: { cmp } } = getState();
  const { availability: { availablityDate },
    availabilityBookingConfig: { totalCollectibleAmount, totalFare },
    train: { trainNumber, frmStnCode, toStnCode, trainType },
    selectedClass, selectedQuota } = railInfo;

  const body = {
    'bookMode': 'D',
    bookingDevice: 'DESKTOP',
    'travelDestinationCity': toStnCode,
    'travelStartDate': availablityDate,
    'travelDepartureCity': frmStnCode,
    'travellerCount': 1,
    'mmtAuth': mmtAuth,
    ...(cmp && { cmpId: cmp }),
    'trainDetails': [ {
      'trainNo': trainNumber,
      bookingQuota: Quotas?.[selectedQuota]?.value || selectedQuota,
      'class': selectedClass,
      'trainType': TrainTypes?.[trainType?.[0]]?.value || trainType?.[0] || '',
      'travelStartDate': availablityDate,
      'trainDepartureCity': frmStnCode,
      'trainDestinationCity': toStnCode,
      'transactionAmountPreTax': totalFare,
      'transactionAmount': totalCollectibleAmount,
    } ],
  };
  try {
    const promiseRecommendedCoupon = axios.post(`${SERVER_URL}/coupon/recommend`, body, {
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
        'Mmt-My-Business-Subscription': 'b2c',
        'mmtAuth': mmtAuth,
        "X-Trace-Id": traceId
      },
    });
    promiseRecommendedCoupon
      .then(({ data: r }) => {
        let coupons = body && body?.trainDetails[0] && r?.couponDetails?.[body.trainDetails?.[0]?.trainNo];
        dispatch({
          type: ADD_RECOMMENDED_COUPONS,
          payload: coupons,
        });
      });
  } catch (error) {
    const coupons = { errorDetails: { errorMessage: 'Please use a valid coupon' } };
    dispatch({
      type: ADD_RECOMMENDED_COUPONS,
      payload: coupons,
    });
  }
};

export const fetchCancellationApi = () => async(dispatch, getState) => {
  const traceId = generateId();
  dispatch({
    type: ACTION_RAILOFY_LOADING,
    payload: {
      isLoading: true
    },
  });
  try {
    const isB2b = isBussinessUser();
    const { listing, traveller: { railInfo, railofy: { railofyOption } = {} },abConfig } = getState();
    const { [fcPlusTgVersion]: fcTgVersion } = abConfig;
    const {availability:{quota, freeCancellationAddonAllowed = false },selectedClass,selectedQuota,doj,train:{trainNumber,frmStnCode,toStnCode}, alternateAvailability,
    altenativeTrainInfo={}, }= railInfo;
    const body = {
      'reservationChoice': '99',
      'source': alternateAvailability ?  altenativeTrainInfo?.frmStnCode : frmStnCode,
      'doj': doj,
      'destination': alternateAvailability ? altenativeTrainInfo?.toStnCode : toStnCode,
      'class': selectedClass,
      'trainNumber': trainNumber,
      'quota': quota || selectedQuota,
      'bookMode': 'D',
      // if railsConfirmationGuaranteeOption is -1 (default) the node backend will make a Pokus call to fetch
      // the latest value. This is required when travellers page is refreshed.
      railsConfirmationGuaranteeOption: _get(listing, 'railofyPokus.railsConfirmationGuaranteeOption', -1),
      railofyShown: railofyOption.railofyShown || false,
      zcShown: railofyOption.zcShown || false,
      ...(isB2b && { freeCancellationAddonAllowed: freeCancellationAddonAllowed }),
      pokusState: {
        [fcPlusTgVersion]: fcTgVersion,
      }
    };
    const mmtauth = getMMTAuth();
    const headers = {
      ...(mmtauth && { 'mmt-auth': mmtauth}),
      deviceid: getDeviceId(),
      'mmt-device-id': getDeviceId(),
      ...(isB2b && { 'mmt-my-business-subscription': 'b2b' }),
      "X-Trace-Id": traceId,
     ...(isHdfcSmartBuyUrl() && { "affiliate": "HDFC_SB"})
    };
    const res = await axios.post(`${SERVER_URL}/enquiry/cnfmGuaranteePreferences`, body, { headers });

    if (res.data.response) {
      dispatch({
        type: ACTION_RAILOFY_RESPONSE,
        payload: res.data.response,
      });
    }
  } catch (error) {
    console.error(error);
  } finally {
    dispatch({
      type: ACTION_RAILOFY_LOADING,
      payload: {
        isLoading: false,
      },
    });
  }
};

export const updateFreeCancellationOption = (freeCancellationSelected, selectedIndex) => (dispatch) => {
  dispatch({
    type: ACTION_SET_FREE_CANCELLATION,
    payload: {
      freeCancellationSelected,
      selectedIndex,
    },
  });
};

export const setAddress = (val) => (dispatch) => {
  dispatch({
    type: SET_ADDRESS_LINE1,
    payload: val,
  });
  dispatch(validateAddress());
};

export const setStreet = (val) => (dispatch) => {
  dispatch({
    type: SET_ADDRESS_LINE2,
    payload: val,
  });
  dispatch(validateStreet());
};

export const setColony = (val) => (dispatch) => {
  dispatch({
    type: SET_ADDRESS_LINE3,
    payload: val,
  });
  dispatch(validateColony());
};

export const setPinno = (val) => (dispatch) => {
  dispatch({
    type: SET_PINCODE,
    payload: val,
  });
  dispatch(validatePinCode());
};

export const setState = (val) => (dispatch) => {
  dispatch({
    type: SET_STATE,
    payload: val,
  });
};

export const setCity = (val) => (dispatch) => {
  dispatch({
    type: SET_CITY,
    payload: val,
  });
};
export const setPostOffice= (val) => (dispatch) => {
  dispatch({
    type: SET_POST_OFFICE,
    payload: val,
  });
};

export const validateAddress = () => (dispatch, getState) => {
  const { traveller: { psgnDestinationAddress: { address } } } = getState();
  let error, errorMsg;
  if (address.length ===0 ) {
    error = true;
    errorMsg = 'Address field cannot be empty. Please enter a valid address.';
  }
  else if (address.length<3) {
    error = true;
    errorMsg = 'Address has to between 3 and 255 characters. ';
  }
  else {
    error = false;
    errorMsg = '';
  }
  dispatch({
    type: SET_ERROR_ADDL1,
    payload: { error, errorMsg },
  });

};
export const validateStreet = () => (dispatch, getState) => {
  const { traveller: { psgnDestinationAddress: { street } } } = getState();
  let error, errorMsg;
  if (street.length === 0) {
    error = false;
    errorMsg = '';
  }
  else if (street.length < 3) {
    error = true;
    errorMsg = 'Address has to between 3 and 255 chars. ';
  }
  else {
    error = false;
    errorMsg = '';
  }
  dispatch({
    type: SET_ERROR_ADDL2,
    payload: { error, errorMsg },
  });
};
export const validateColony = () => (dispatch, getState) => {
  const { traveller: { psgnDestinationAddress: { colony } } } = getState();
  let error, errorMsg;
  if (colony.length === 0) {
    error = false;
    errorMsg = '';
  }
  else if (colony.length < 3) {
    error = true;
    errorMsg = 'Address has to between 3 and 255 chars. ';
  }
  else {
    error = false;
    errorMsg = '';
  }
  dispatch({
    type: SET_ERROR_ADDL3,
    payload: { error, errorMsg },
  });
};

export const setPostOfficeList = (arr) => (dispatch, getState) => {
  dispatch({
    type: SET_POST_OFFICE_LIST,
    payload: arr,
  });
};

export const validatePinCode = () => async(dispatch, getState) => {
  const traceId = generateId();
  const { traveller: { psgnDestinationAddress: { pinCode, postOffice } } } = getState();
  let error, errorMsg;
  if (pinCode.length !== 6) {
    error = true;
    errorMsg = 'Pincode has to be 6 digits';
  }
  else if (pinCode.length === 6) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        "X-Trace-Id": traceId
      },
    };
    const { data: respJson } = await axios.post(`${SERVER_URL}/booking/getAddressByPin`, { pinCode },  config);
    if (respJson.status !== 'SUCCESS') {
      error = true;
      errorMsg = 'Invalid Pin Code';
    }
    else {
      error = false;
      errorMsg = '';
      dispatch(setCity(respJson.data.city));
      dispatch(setState(respJson.data.state));
      dispatch(setPostOfficeList(respJson.data.postOfficeList));
      dispatch(setPostOffice(postOffice || respJson.data.postOfficeList[0]));
    }
  }
  if (error) {
    dispatch(setCity(''));
    dispatch(setState(''));
    dispatch(setPostOffice(''));
    dispatch(setPostOfficeList([]));
  }
  dispatch({
    type: SET_ERROR_PINNO,
    payload: { errorMsg, error },
  });
};

export const validateIrctcUserId = () => (dispatch) => {
  const verifiedUserId = getItemBySession(
    STORAGE_CONSTANTS.VERIFIED_USER_ID,
    { isPiiData: true, shouldParseJson: true },
    itemType.ES
  );
  if (!verifiedUserId) {
    const errorMsg = 'Please enter IRCTC Username to continue';
    dispatch({
      type: SET_ERROR_IRCTC_USER_ID,
      payload: { error: true, errorMsg },
    });
  }
};

export const validateAddressAll = () => (dispatch, getState) => {
  dispatch(validateAddress());
  dispatch(validateStreet());
  dispatch(validatePinCode());
  dispatch(validateColony());
  dispatch(validateIrctcUserId());
};

export const getAddressFromLs = () => (dispatch) => {
  try {
    const addressFromLs = JSON.parse(localStorage.getItem(ADDRESS_LS_KEY));
    if (addressFromLs) {
      const {
        psgnDestError = {},
        psgnDestErrorMsg = {},
        psgnDestinationAddress = {},
        postOfficeList = [],
      } = addressFromLs;
      dispatch({
        type: GET_ADDRESS_FROM_LS,
        payload: {
          psgnDestError,
          psgnDestErrorMsg,
          psgnDestinationAddress,
          postOfficeList,
        },
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const onSelectCNFMGuarantee = (selectedIndex, isSelected) => (dispatch) => {
  dispatch({
    type: ACTION_ON_SELECT_CNFM_GUARANTEE,
    payload: {
      selectedIndex,
      isSelected,
    },
  });
};

export const actionShowRailofyError = (showError) => (dispatch) => {
  dispatch({
    type: ACTION_RAILOFY_ERROR,
    payload: showError,
  });
}

export const actionZCShowError = (showError) => (dispatch) =>{
  dispatch({
    type: ACTION_ZCSHOW_ERROR,
    payload: showError,
  })
}

export const actionfcTgFirstSelection = (payload) => (dispatch) =>{
  dispatch({
    type: ACTION_FC_TG_FIRST_SELECTION,
    payload: payload,
  })
}

export const gstinComponentVisibility = () => async (dispatch, getState) => {
  const traceId = generateId();
  const {
    login: {
      isLoggedIn,
    }
  } = getState();

  if(!isLoggedIn) {
    return dispatch(showGSTINcomponent(true));
  }

  const mmtId = getCookie(MMT_AUTH);

  try {
    const headers = {
      "mmt-auth": getCookie(MMT_AUTH),
      "mmt-device-id": getDeviceId(),
      "X-Trace-Id": traceId
    };
    const res = await axios.get(`${SERVER_URL}/user/addressDetails`, { headers });
    const data = res?.data;

    if(data?.addressDetails.length > 0) {
     return dispatch(showGSTINcomponent(false));
    }
  } catch(err) {
    return err;
  }
  dispatch(showGSTINcomponent(true));
}

export const gstinStateUpdate = (gstin_state) => (dispatch) => {
  dispatch(setGstinState(gstin_state));
}

export const gstinUserConsentUpdate = (gstin_userconsent) => (dispatch) => {
  dispatch(setGstinUserconsent(gstin_userconsent));
}

export const gstinUserConsentErrorUpdate = (gstin_userconsentError) => (dispatch) => {
  dispatch(setGstinUserConsentError(gstin_userconsentError));
}

export const gstinStateErrorUpdate = (gstin_stateError) => (dispatch) => {
  dispatch(setGstinStateError(gstin_stateError));
}

export const actionSetOrResetLoginModal = showLoginModal => {
  const showHdfcSmartBuy = isHdfcSmartBuyUrl()
  if (showHdfcSmartBuy) {
    const affLoginSpan = document.querySelector(".affLogin");
    if (affLoginSpan) {
      affLoginSpan.click();
    }
  }

  return {
    type: ACTION_SET_OR_RESET_LOGIN_MODAL,
    payload: showLoginModal
  };
};

export const actionShowIrctcVerificationModal = (showModal) => ({
  type: ACTION_SHOW_IRCTC_VERIFICATION_MODAL,
  payload: showModal
});

export const showGSTINcomponent = (showgstin) => ({
  type: SHOW_GSTIN_COMPONENT,
  payload: showgstin
});

export const setGstinState = (gstin_state) => ({
  type: GSTIN_STATE,
  payload: gstin_state
});

export const setGstinUserconsent = (gstin_userconsent) => ({
  type: GSTIN_USERCONSENT,
  payload: gstin_userconsent
})

export const setGstinUserConsentError = (gstin_userconsentError) => ({
  type: GSTIN_USERCONSENT_ERROR,
  payload: gstin_userconsentError
});

export const setGstinStateError = (gstin_stateError) => ({
  type: GSTIN_STATE_ERROR,
  payload: gstin_stateError
});

export const fetchAvailabilitySubscription = (actionType) => async (dispatch, getState) => {
  try {
    const state = getState();
    const {
      traveller: {
        railInfo = {},
        availabilitySubscription: { isAvailSubscrnEnabled } = {},
      } = {},
    } = state || {};

    if (!railInfo || typeof railInfo !== 'object') {
      console.warn('AvailabilitySubscription: railInfo is missing or invalid');
      return;
    }

    if (isEmpty(railInfo)) {
      console.warn('AvailabilitySubscription: railInfo is empty, returning early');
      return;
    }

    const {
      selectedQuota,
      selectedClass,
      doj,
      train: { frmStnCode, toStnCode, departureDateAndTime, trainNumber } = {},
      availability: { availablityDate, availablityStatus, availablityType } = {},
    } = railInfo;

    if (!trainNumber || !frmStnCode || !toStnCode || !doj || !selectedClass || !selectedQuota) {
      console.warn('AvailabilitySubscription: Missing required data for API call');

      return;
    }
    let formattedDate;
    try {
      const year = doj.substring(0, 4);
      const month = doj.substring(4, 6);
      const day = doj.substring(6, 8);
      const dateString = `${year}-${month}-${day}`;
      
      const dateObj = new Date(dateString);
      
      if (isNaN(dateObj.getTime())) {
        throw new Error('Invalid date');
      }
      formattedDate = fecha.format(dateObj, 'YYYYMMDD');
    } catch (error) {
      console.error('AvailabilitySubscription: Error formatting date:', error);
      return;
    }

    const body = {
      srcStation: frmStnCode,
      dstnStation: toStnCode,
      departureDate: formattedDate,
      trainNumber,
      journeyClass: selectedClass,
      quota: selectedQuota,
      availabilityDetails: {
        availablityDate: availablityDate || '',
        availablityStatus: availablityStatus || '',
        availablityType: availablityType || '',
      },
      ...(actionType === AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES.UPDATE && {
        subscribe: !isAvailSubscrnEnabled,
      }),
    };

    const traceId = generateId();
    const isLoggedIn = isUserLoggedIn();

    const headers = {
      "mmt-device-id": getDeviceId(),
      "X-Trace-Id": traceId
    };

    if (isLoggedIn) {
      const mmtAuth = getCookie(MMT_AUTH);
      if (mmtAuth) {
        headers['mmt-auth'] = mmtAuth;
      }
      
      try {
        const userInfo = await getUserInfoPIIClient();
        const uuid = userInfo?.uuid || '';
        if (uuid) {
          headers['mmt-uuid'] = uuid;
          headers['uuid'] = uuid;
        }
              } catch (error) {
        console.warn('Could not get user UUID for availability subscription');
      }
    }

    if (actionType === AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES.UPDATE && !headers['mmt-auth']) {
      console.error('AvailabilitySubscription: mmt-auth is required for subscription update');
      return;
    }

    const apiUrl = actionType === AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES.INITIALISE
      ? railsConfig.getAvailabilitySubscrnStatus
      : railsConfig.updateAvailabilitySubscrnStatus;

    const response = await axios.post(apiUrl, body, { headers });
    const res = response?.data;

    if (!res) {
      console.error('AvailabilitySubscription: No response data received');
      return;
    }

    if (res?.error?.errorMessage && actionType === AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES.UPDATE) {
      console.error('AvailabilitySubscription error:', res?.error?.errorMessage);
    } else if (actionType === AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES.INITIALISE) {
      dispatch({
        type: ACTION_ON_AVAIL_SUBSCRN,
        data: {
          isAvailSubscrnEnabled: res?.subscriptionDetails?.subscribed || false,
          showSubscriptionWidget: res?.showSubscriptionWidget || false,
        },
      });
    } else if (
      actionType === AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES.UPDATE &&
      res?.subscriptionDetails
    ) {
      const currentSubscriptionStatus = state?.traveller?.availabilitySubscription?.isAvailSubscrnEnabled || false;
      const newSubscriptionStatus = res?.subscriptionDetails?.subscribed || false;
      
      let toastMessage = '';
      if (newSubscriptionStatus && !currentSubscriptionStatus) {
        toastMessage = AVAILABILITY_ALERT_SET_SUCCESSFULLY;
      } else if (!newSubscriptionStatus && currentSubscriptionStatus) {
        toastMessage = AVAILABILITY_ALERT_REMOVED_SUCCESSFULLY;
      }

      dispatch({
        type: ACTION_ON_AVAIL_SUBSCRN,
        data: {
          isAvailSubscrnEnabled: newSubscriptionStatus,
          showToast: !!toastMessage,
          toastMessage: toastMessage,
        },
      });
      }
    } catch (error) {
      console.error('AvailabilitySubscription API error:', error.message);
    }
};

export { AVAILABILITY_SUBSCRIPTION_REQUEST_TYPES };
export const updateReviewVerificationFlow = (data) => ({
  type: UPDATE_REVIEW_VERIFICATION_FLOW,
  payload: data
});
